import { z } from 'zod';
import { OrganizationRoles, Organizations, OrganizationInvitations, } from '../db-entries/index.js';
import { userInfoGuard } from './user.js';
// TODO @wangsijie - Remove this once the feature is ready
export const organizationRoleWithScopesGuardDeprecated = OrganizationRoles.guard.extend({
    scopes: z
        .object({
        id: z.string(),
        name: z.string(),
    })
        .array(),
});
export const organizationRoleWithScopesGuard = OrganizationRoles.guard.extend({
    scopes: z
        .object({
        id: z.string(),
        name: z.string(),
    })
        .array(),
    resourceScopes: z
        .object({
        id: z.string(),
        name: z.string(),
        resource: z.object({
            id: z.string(),
            name: z.string(),
        }),
    })
        .array(),
});
const organizationRoleEntityGuard = z.object({
    id: z.string(),
    name: z.string(),
});
export const organizationWithOrganizationRolesGuard = Organizations.guard.extend({
    organizationRoles: organizationRoleEntityGuard.array(),
});
export const userWithOrganizationRolesGuard = userInfoGuard.extend({
    organizationRoles: organizationRoleEntityGuard.array(),
});
export const organizationInvitationEntityGuard = OrganizationInvitations.guard.extend({
    organizationRoles: organizationRoleEntityGuard.array(),
});
